var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center"},[_vm._v("\n  "+_vm._s(_vm.params.value)+"  \n  "),_c('feather-icon',{attrs:{"icon":"CrosshairIcon","svgClasses":"h-5 w-5 mr-4 hover:text-primary cursor-pointer"},on:{"click":_vm.editRecord}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }